<div>
    <mat-sidenav-container [hasBackdrop]="false" autosize>
        <mat-sidenav #sidenav mode="side" opened style="display: block;">

            <div>
                <div class="heading"> Search Form
                </div>
                <div class="input-group-sm mt-2 input-group col-12">
                    <input class="form-control" type="search" placeholder="From Date">
                    <!-- <mat-icon *ngIf = "filterValue" (click)="document.getElementById('filterInput').value = ''">close</mat-icon> -->
                </div>
                <div class="input-group-sm mt-2 input-group col-12">
                    <input class="form-control" type="search" placeholder="To Date">
                    <!-- <mat-icon *ngIf = "filterValue" (click)="document.getElementById('filterInput').value = ''">close</mat-icon> -->
                </div>
                <div class="clearfix mt-2 mr-1">
                    <button mat-stroked-button class="float-right">
                    <mat-icon>search</mat-icon> Search
                    </button>
                </div>
            </div>

        </mat-sidenav>
        <mat-sidenav-content style="margin-right: 0; padding:0; height: calc(100vh - 50px);">

            <div class="container-fluid">
                <!-- Please don't remove this button!!!! -->
                <button type="button" class="mt-1" mat-stroked-button (click)="sidenav.toggle()">
                    <div *ngIf="sidenav.opened">Hide Search Form</div>
                    <div *ngIf="!sidenav.opened">Show Search Form</div>
                </button>                
            </div>


            <div class="container-fluid">
                <ejs-accumulationchart id="chart-container" [title]="chartHeading" [tooltip]="toolTipSettings">
                    <e-accumulation-series-collection>
                        <e-accumulation-series [dataSource]='data' innerRadius = "70%" xName='type' yName='count' type='Pie' innerRadius="40%" [dataLabel]="chartLabel" [palettes]="palette"></e-accumulation-series>
                    </e-accumulation-series-collection>
                  </ejs-accumulationchart>
            </div>

        </mat-sidenav-content>
    </mat-sidenav-container>
</div>